module.exports = __webpack_public_path__ + "img/person_add_alt_1-24px.d6bc61b9.svg";